import { useQuery } from 'react-apollo'
import { ListPackageCategories } from '../../../graphql/packages/queries'
import { PackageCategoryFilter, PackageCategorySort, PackageCategoryPage } from '@labsavvyapp/components'

/**
 *  Query to get a list of Partners based on user

 * @returns Provider
 */

interface ListPackageCategoriesVariables {
  limit?: number
  page?: number
  filter?: PackageCategoryFilter
  sort?: PackageCategorySort
}

export const useQueryListPackageCategoriesApi = (variables: ListPackageCategoriesVariables) => {
  const { limit, page, filter, sort } = variables

  const {
    data: listPackageCategoriesData,
    error: listPackageCategoriesError,
    loading: listPackageCategoriesLoading,
    refetch: refetchListMyPartnersData,
  } = useQuery(ListPackageCategories, {
    variables: {
      limit: limit,
      page: page,
      filter: filter,
      sort: sort,
    },
  })

  return {
    data: listPackageCategoriesData,
    error: listPackageCategoriesError,
    loading: listPackageCategoriesLoading,
    refetch: refetchListMyPartnersData,
  }
}
